import { Alert } from '@televet/kibble-ui/Alert';
import { Button } from '@televet/kibble-ui/Button';
import { Text } from '@televet/kibble-ui/Text';
import { Flex } from '@televet/kibble-ui/chakra';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';
import { Breadcrumbs } from '@/components/Breadcrumbs';
import { PageContainer } from '@/components/PageContainer';
import { trpc } from '@/lib/trpc';
import { ClinicPets } from '../-components/ClinicPets';
import { ClinicSummary } from '../-components/ClinicSummary';
import { petListSearchSchema } from '../-lib/listing';

const RouteComponent = () => {
  const { clinicId } = Route.useParams();
  const navigate = Route.useNavigate();
  const { list } = Route.useSearch();

  const { data: conditions } = useQuery(trpc.petConditions.listConditionOptions.queryOptions());
  const clinic = useQuery(trpc.petConditions.getClinic.queryOptions({ clinicId }));

  return (
    <PageContainer>
      <Flex direction="column" w="100%" gap={4}>
        <Breadcrumbs
          items={[
            { label: 'Pet Conditions', to: '/pet-conditions' },
            { label: clinic.data?.name ?? clinicId },
          ]}
        />

        <Flex justify="space-between" align="center" gap={3} wrap="wrap">
          <Text fontSize="lg" fontWeight="semibold" letterSpacing="-0.01em">
            {clinic.data?.name ?? 'Clinic'}
          </Text>
          {/* Opened from a link with no `list`, the bare URL restores the last saved filters instead. */}
          <Button
            variant="secondary"
            size="sm"
            iconName="arrowLeft"
            onClick={() => navigate({ to: '/pet-conditions', search: list ?? {} })}
            data-testid="pet-conditions-back-to-clinics"
          >
            Back to clinics
          </Button>
        </Flex>

        {clinic.isError && (
          <Alert
            status="error"
            hideCloseButton
            title="Could not load this clinic"
            description={clinic.error?.message ?? 'The request failed.'}
          />
        )}

        {clinic.data && <ClinicSummary clinic={clinic.data} />}

        <ClinicPets clinicId={clinicId} conditions={conditions ?? []} />
      </Flex>
    </PageContainer>
  );
};

export const Route = createFileRoute('/_authenticated/pet-conditions/clinics/$clinicId')({
  component: RouteComponent,
  validateSearch: petListSearchSchema,
});
